import { Checkbox, TableCell, Typography } from '@mui/material';
import TableRow from '@mui/material/TableRow';
import AppTableCell from 'src/components/appComponents/table/AppTableCell';
import Label from 'src/components/label';
import { IYoutubeVideosByChannelDto } from 'src/types/parentSuggestion';

export default function PublishChannelTableRow({
  row,
  selected,
  onSelectRow,
  setVideoLink,
  showVideo,
}: any) {
  return (
    <>
      <TableRow hover>
        <TableCell padding="checkbox">
          <Checkbox checked={selected} onChange={onSelectRow} />
        </TableCell>
        <AppTableCell value={row?.title} />
        <AppTableCell
          value={
            <Typography
              sx={{ textDecoration: 'underline', cursor: 'pointer' }}
              fontWeight={500}
              onClick={() => {
                setVideoLink('https://youtu.be/' + row?.videoId);
                showVideo.onTrue();
              }}
            >
              Preview
            </Typography>
          }
        />
        <AppTableCell value={row?.type} />
      </TableRow>
    </>
  );
}
